(function(w, $) {
    var pubSub = w.PubSub;

    if (pubSub) {
        // Listen to the messages on global notifications channel
        pubSub.subscribe('notification', showNotification);

        if (w.notifyMessages) {
            w.notifyMessages.forEach(function (message) {
                pubSub.publish('notification', message);
            });
        }
    }

    function showNotification(topic, contract) {
        const topicParts = topic.split('.');
        const notificationType = topicParts.length > 1 ? topicParts[topicParts.length - 1] : 'information';

        let defaultOptions = {
            layout: 'topCenter',
            type: notificationType,
            maxVisible: 15,
            force: true,
            timeout: 5000
        };

        const notyCallback = typeof (contract) === 'object' && contract && contract.notyCallback && typeof (contract.notyCallback) === 'function' ? contract.notyCallback : null;

        let notyOptions = typeof (contract) === 'object' && contract ? $.extend(true, defaultOptions, contract) : $.extend(defaultOptions, { text: contract });

        if (w.siteScripts) {
            notyOptions = w.siteScripts.converters.apply('NotyOptionsConverters', notyOptions);
        }

        const notyMsg = w.noty(notyOptions);

        if (notyCallback) {
            notyCallback(notyMsg);
        }
    }
})(window, jQuery);